<script>
export default {
  props: {
    clipSide: {
      type: String,
      default: '',
    },
    clickActive: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <button
    :class="['btnClip', 'clip' + clipSide, clickActive]"
    v-on="$listeners"
  >
    <div class="z-100">
      <slot />
    </div>
  </button>
</template>

<style lang="scss">
@import '@design';

.btnClip {
  @extend %btnClip;

  position: relative;
  padding: 0.5rem 1rem;
  font-size: 1.3rem;
  font-weight: 900;
  color: $primary;
  text-align: left;
  text-decoration: none;
  background: $white;
  border: none;

  span {
    font-size: 1rem;
    font-weight: normal;
  }

  &.clipLeft {
    margin-left: 25px;
  }

  &.clipLeft::before {
    position: absolute;
    top: 0;
    left: -30px;
    z-index: 50;
    width: 60px;
    height: 100%;
    content: '';
    background: $white;
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 50% 100%);
  }

  &.clipRight::after {
    position: absolute;
    top: 0;
    right: -30px;
    z-index: 50;
    width: 60px;
    height: 100%;
    content: '';
    background: $white;
    clip-path: polygon(0 0, 100% 0%, 50% 100%, 0 100%);
  }

  &:hover:not(.inactive) {
    color: $white;
    text-decoration: none;
    cursor: pointer;
    background: $primary;
    opacity: 0.85;

    &.clipRight::after,
    &.clipLeft::before {
      background: $primary;
    }
  }
}
</style>
